var _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTabGuard = function SvgTabGuard(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg70",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path88",
    fill: "currentColor",
    strokeWidth: 0.64,
    d: "M15.726.588c-.491 0-2.554.833-4.584 1.851s-4.948 2.188-6.486 2.6l-2.797.75.426 4.133c.804 7.798 4.136 14.388 9.767 19.314 1.649 1.442 3.303 2.623 3.676 2.623s1.785-.763 3.139-1.696c4.623-3.184 9.746-11.73 10.455-17.445.196-1.582.473-3.804.615-4.937.245-1.948.11-2.1-2.428-2.78-1.477-.394-4.533-1.55-6.789-2.566S16.217.587 15.726.587zm.627 9.642c1.51 0 2.732 1.046 2.732 2.336 0 .648-.315 1.266-.869 1.707-.415.926-.177 2.172.144 3.588l.227 2.51H13.88l.417-3.094c.005-1.056.135-1.916.201-2.629-.25-.36-.878-1.664-.88-2.082 0-1.29 1.225-2.336 2.735-2.336"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "path84",
    cx: 16.6,
    cy: 13.262,
    fill: "none",
    rx: 2.684,
    ry: 2.634
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabGuard);
export default ForwardRef;